import api from '@/apis/di/defaultAccountAPI.js';
import Crud from '@/stores/crudBase';
import { ModuleDefaultAccountCache } from '@/stores/moduleConst';
import store from '@/stores/store';
var crud = new Crud('defaultAccount', api);

const state = {
  ...crud.state,
  _config: {
    table: 'sys_ref_type',
    field: {
      key: 'ref_type',
      //   code: '',
      name: 'ref_type_name',
      //   quickFollow: '',
    },
  },
};

const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
  /**
   * Đồng bộ sang dữ liệu cache combo
   * @param {*} state
   * @param {*} items
   * NXCHIEN 06.02.2024
   */
  updateItem: (state, item) => {
    crud.mutations.updateItem(state, item);
    store.dispatch(`${ModuleDefaultAccountCache}/updateItemCombo`, item);
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
